<template>
  <div>
    <properties />
    <onlineChart />
    <onlineChartTrend />
    <!--图形化展示-->
    <graphiCally />
    <!--记事本-->
    <nodeBook />
    <dataInterface />
    <topic />
    <door />
    <users />
    <!--计算工具-->
    <countBook />
    <!--趋势日志-->
    <trendJournal />
    <trendJournalExpress />
    <change-of-state />
    <create-user />
    <create-group />
    <user />
    <group />
    <authority />
    <alarmReceiver />
    <alarm-control />
    <alarm-group />
    <deviceDialog />
    <!--// 程序的下载-->
    <orderDialog />
    <trendLogs />
    <pointDialog />
    <addFolder />
    <addFolderDesgin />
    <time-chart />
    <timeChartBatch />
    <timeChartValue />
    <holiday />
    <device-list />
    <search-dialog />
    <object-transfer />
    <time-event-object />
    <time-event-list />
    <energyDialog />
    <energyBar />
    <eneryStatictics />
    <coilDialog />
    <squaerDialog />
    <ruleDialogShow />
    <statisticsModule />
    <EHI />
    <hkvideo />
    <valueCalculation />
  </div>
</template>

<script type="text/ecmascript-6">
import properties from "./left-side/properties";
import onlineChart from "./left-side/onlineChartPropertity";
import onlineChartTrend from "./left-side/onlineChartTrend";
// 图形化展示
import graphiCally from "./graphically/graphically";
import createUser from "./authority/createUser";
import createGroup from "./authority/createGroup";
import user from "./authority/user";
import group from "./authority/group";
import authority from "./authority/authority";
import alarmReceiver from "./alarmReceiver/alarmReceiver";
import changeOfState from "./alarm/changOfState";
import alarmControl from "./alarm/alarmControl";
import alarmGroup from "./alarm/alarmGroup";
import deviceDialog from "./deviceAbout/device";
// 程序的下载
import orderDialog from "./deviceAbout/orderDevice";
// 记事本
import nodeBook from "./notebook/notebook";
// 数据接口
import dataInterface from "./notebook/dataInterface";
import topic from "./notebook/topic";
import door from "./notebook/door";
import trendLogs from "./notebook/trendLogs";
import users from "./notebook/userManage";
import countBook from "./notebook/countbook";
import holiday from "./timeChart/holidayPianning";
// 趋势日志
import trendJournal from "./trendJournal/trendjournal";
import trendJournalExpress from "./trendJournal/trendJournalExpress";
import pointDialog from "./point/point";
import addFolder from "./left-side/addFolder";
import addFolderDesgin from "./left-side/addFolder-desgin";
import timeChart from "./timeChart/timeChart"; // 时间表
import timeChartBatch from "./timeChart/timeChartBatch"; // 时间表
import timeChartValue from "./timeChart/timeChartValue"; // 时间表
import energyDialog from "./timeChart/energyDialog.vue"; // 能耗计算窗口
import coilDialog from "./timeChart/coilDialog.vue"; // 能耗计算窗口
import squaerDialog from "./timeChart/squareDialog.vue"; // 创建方波
import eneryStatictics from "./timeChart/energyStatiscs.vue";
import energyBar from "./timeChart/energyBar.vue";
import deviceList from "./deviceList/deviceList";
import searchDialog from "./search/search";
import objectTransfer from "./objectTransfer/objectTransfer";
import timeEventObject from "./timeEvent/timeEventObject";
import timeEventList from "./timeEvent/timeEventList";
import ruleDialogShow from "./other/ruleDialog";
import statisticsModule from "./statisticModule/Index.vue";
import EHI from "./EHI/Index.vue";
import hkvideo from "./hkVideo/Index.vue";
import valueCalculation from "./point/valueCalculation.vue";
export default {
  components: {
    ruleDialogShow,
    squaerDialog,
    coilDialog,
    eneryStatictics,
    statisticsModule,
    EHI,
    hkvideo,
    properties,
    energyBar,
    onlineChart,
    onlineChartTrend,
    // 图形化展示
    graphiCally,
    // 记事本
    nodeBook,
    dataInterface,
    topic,
    door,
    trendLogs,
    users,
    // 计算工具
    countBook,
    // 趋势日志
    trendJournal,
    trendJournalExpress,
    createUser,
    createGroup,
    user,
    group,
    authority,
    alarmReceiver,
    changeOfState,
    alarmControl,
    alarmGroup,
    deviceDialog,
    // 程序的下载
    orderDialog,
    // 能耗计算
    energyDialog,
    pointDialog,
    addFolder,
    addFolderDesgin,
    timeChart,
    timeChartBatch,
    holiday,
    deviceList,
    searchDialog,
    objectTransfer,
    timeEventObject,
    timeEventList,
    valueCalculation, // 值计算
    timeChartValue
  },
  data() {
    return {};
  },
  watch: {},
  created() { },
  mounted() { },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/components/dialog.vue